/**
 * Native action button with label/icon/suffix slots and form submission.
 * @element qds-button
 * @attr {string} label - Visible fallback label; the default slot supplies visible content.
 * @attr {string} aria-label - Explicit accessible action name.
 * @attr {'primary'|'secondary'|'quiet'|'destructive'} variant - Visual treatment; default primary.
 * @attr {'sm'|'md'|'lg'} size - Visual size; targets remain at least 44px.
 * @attr {boolean} disabled - Blocks activation and submission.
 * @attr {boolean} loading - Busy indicator; blocks repeated activation.
 * @attr {'button'|'submit'|'reset'} type - Native form action; default button.
 * @attr {string} name - Submitter field name.
 * @attr {string} value - Submitter field value.
 * @attr {string} form - Associated form ID.
 * @attr {string} formaction - Overrides form action.
 * @attr {string} formenctype - Overrides form encoding.
 * @attr {string} formmethod - Overrides form method.
 * @attr {boolean} formnovalidate - Skips validation for this submitter.
 * @attr {string} formtarget - Overrides form target.
 * @attr {string} aria-pressed - Optional toggle state.
 * @attr {string} aria-expanded - Optional disclosure state.
 * @attr {string} aria-controls - Controlled content ID.
 * @slot - Visible action content; overrides the label attribute fallback.
 * @slot icon - Leading decorative icon.
 * @slot suffix - Trailing decorative content.
 * @csspart button - Native button.
 * @csspart label - Label slot.
 * @csspart icon - Leading icon slot.
 * @csspart suffix - Trailing slot.
 * @csspart spinner - Decorative busy indicator.
 * @fires click - Cancelable activation, detail { component }; preventDefault cancels the form action.
 */
import { QdsButtonBase } from '../shared/button-base.js';
export class QdsButton extends QdsButtonBase {}
if (!customElements.get('qds-button')) customElements.define('qds-button', QdsButton);
